import React from 'react';

const Logo = ({ fill }) => (
  <div>
    <img 
      width="200"
      alt="Resumaker Logo"
      style={{marginLeft: fill === '#000' ? -10 : -15}}
      src={`/resumaker-logo${fill === '#000' ? '-dark' : ''}.png`}
    />
    <div>
        <a 
          target="_blank" 
          rel="noopener noreferrer" 
          style={{color: '#5b4f96'}}
          href="https://resumaker.me" 
          onClick={e => e.stopPropagation()}
        >
          Home
        </a>
        <a 
          target="_blank"
          rel="noopener noreferrer" 
          href="https://app.resumaker.me" 
          onClick={e => e.stopPropagation()}
          style={{color: '#5b4f96', marginLeft: 15}}
        >
          Create Resume
        </a>
    </div>
  </div>
);

export default Logo;